import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Logo from "@/components/Logo";

// Thank-you page: SPANISH ONLY per spec
export default function ThankYou() {
  return (
    <main
      className="min-h-screen flex items-center justify-center relative overflow-hidden bg-[#0F172A] text-[#FAF9F6] px-6"
      data-testid="thank-you-page"
    >
      <div className="grain absolute inset-0" />
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[70vw] h-[70vw] rounded-full bg-[#D97706]/15 blur-[120px]" />
      </div>

      <div className="relative container-x max-w-3xl text-center">
        <div className="flex justify-center mb-8">
          <Logo tone="paper" />
        </div>

        <div className="eyebrow text-[#D97706]">Mensaje enviado</div>

        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: [0.2, 0.7, 0.2, 1] }}
          className="mt-5 font-serif-display text-5xl md:text-7xl leading-[0.98] tracking-tight"
        >
          Gracias por escribirnos.
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.2 }}
          className="mt-6 text-[#FAF9F6]/70 leading-relaxed max-w-xl mx-auto"
        >
          Recibimos tu mensaje y lo estamos revisando. Un integrante del equipo se pondrá en contacto en las próximas 24 horas hábiles.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.35 }}
          className="mt-10"
        >
          <Link
            to="/"
            className="btn-pill btn-pill--amber"
            data-testid="thank-you-back-home"
          >
            Volver al inicio <span aria-hidden>→</span>
          </Link>
        </motion.div>

        <div className="mt-16 font-mono-mark text-[0.65rem] tracking-[0.32em] uppercase text-[#FAF9F6]/40">
          Ronavirona S.A. · Buenos Aires · Argentina
        </div>
      </div>
    </main>
  );
}
